import React from 'react';

export default ({ img = false, link = '/step2.mp4' }) =>
  link && (
    <div className="telegram-flow_video">
      {!img && <video controls muted src={link} />}
      {img && <img src={link} />}
    </div>
  );
